<!-- 標題title -->
<template>
  <div class="title">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'primary-title'
}
</script>
<style lang="stylus" scoped>
.title
  font-family fonts!important
  font-size $font-size-lg!important
  text-align left
  color: $primary-color
  font-weight bolder!important
  margin-bottom:20px
</style>
